// The component type used for limiting drag and drop to matching types.
export const COMPONENT = "component";

export const DEFAULT_CHOICE = "---";

export const STORAGE_KEY_PAGES = "createdPages";
